import { AnimatePresence, motion } from "framer-motion"

function PopupAnimation({ children, showDiv }) {
  return (

    <AnimatePresence
      initial={false}
      mode="wait"
      onExitComplete={() => null}
    >
      {showDiv &&
        <motion.div
          style={{ "backgroundColor": "rgba(0, 0, 0, 0.8)" }}
          className="fixed inset-0 z-50 flex items-center justify-center outline-none focus:outline-none"
          transition={{ ease: "easeOut", duration: 0.3 }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          {children}
        </motion.div>
      }
    </AnimatePresence>
  )
}

export default PopupAnimation